<template>
  <generic-view :prepend="url" :steps="steps" not-numbered :loading="loading">
    <introduction v-show="step == 'introduction'" endpoint="auto-inspection" @next-step="next"></introduction>
    <template v-if="sas">
      <div v-for="s in realSteps" :key="s.path">
        <div v-show="step == s.path">
          <headline :code="s.code"></headline>
          <component :is="s.path" :sas="sas" @validation-changed="setState(s.path, $event)" :ref="s.path">
            <ressource :code="s.code" />
          </component>
          <v-btn color="#3a3838" dark class="mt-6" x-large @click="next">Enregistrer et continuer</v-btn>
        </div>
      </div>
      <soumission v-show="step == 'soumission'" :showAlert="formulaireNonValide" @submit="submit" ref="soumission"></soumission>
    </template>
  </generic-view>
</template>

<script>
import Introduction from "@/components/FormParts/Introduction"
import AutoInspectionEtape1 from "@/components/AutoInspection/AutoInspectionEtape1.vue"
import AutoInspectionEtape2 from "@/components/AutoInspection/AutoInspectionEtape2.vue"
import AutoInspectionEtape3 from "@/components/AutoInspection/AutoInspectionEtape3.vue"
import Engagements from "@/components/AutoInspection/Engagements.vue"
import Soumission from "@/components/FormParts/Soumission"
import FormulaireViewBase from "@/mixins/FormulaireViewBase"
import FormulaireBase from "@/mixins/FormulaireBase"

export default {
  mixins: [FormulaireViewBase, FormulaireBase],

  data() {
    return {
      url: "/auto-inspection/",
      paramsName: "auto-inspection",
      steps: [
        { path: "introduction", code: "titre-introduction", state: "" },
        { path: "autoInspectionEtape1", code: "titre-etape-1", state: "" },
        { path: "autoInspectionEtape2", code: "titre-etape-2", state: "" },
        { path: "autoInspectionEtape3", code: "titre-etape-3", state: "" },        
        { path: "engagements", code: "titre-etape-4", state: "" },        
        { path: "soumission", code: "titre-soumission" }
      ]
    }
  },

  components: {
    Introduction,
    AutoInspectionEtape1,
    AutoInspectionEtape2,
    AutoInspectionEtape3,
    Engagements,    
    Soumission
  },

  metaInfo() {
    return {
      title: this.$i18n.t("meta.formulaires.title")
    }
  }
}
</script>

<style>
</style>